import { render, staticRenderFns } from "./AgentTransactionsReportTrademarkList.vue?vue&type=template&id=6c390d41&"
import script from "./AgentTransactionsReportTrademarkList.vue?vue&type=script&lang=js&"
export * from "./AgentTransactionsReportTrademarkList.vue?vue&type=script&lang=js&"
import style0 from "./AgentTransactionsReportTrademarkList.vue?vue&type=style&index=0&id=6c390d41&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports